module.exports = __webpack_public_path__ + "static/media/epic@3x.47507136.png";